import { useState } from 'react'
import LegalModal, { type LegalDoc } from '@/components/LegalModal'
import { CONTACT } from '@/data/content'

const LEGAL_LINK =
  'text-bone-100/70 underline decoration-bone-100/25 underline-offset-4 transition hover:text-bone-50 hover:decoration-bone-100/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pine-400 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950'

export default function Footer() {
  const [legalDoc, setLegalDoc] = useState<LegalDoc | null>(null)

  return (
    <>
      <footer className="bg-forest-950 py-12 text-bone-100">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <div className="flex flex-col gap-8 border-b border-bone-50/10 pb-8 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <p className="font-display text-lg font-semibold text-bone-50">Trimmed Living</p>
              <p className="mt-2 max-w-sm text-sm leading-relaxed text-bone-100/60">
                Custom landscaping and hardscaping, outdoor carpentry, and 12-volt landscape
                lighting. Based in Nash County, NC &bull; Serving {CONTACT.region}.
              </p>
            </div>
            <div className="flex flex-col gap-2 text-sm text-bone-100/70">
              <a href={CONTACT.phoneHref} className="transition hover:text-bone-50">
                {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="transition hover:text-bone-50">
                {CONTACT.email}
              </a>
            </div>
          </div>

          <div className="mt-8 flex flex-col gap-4 text-xs text-bone-100/45 sm:flex-row sm:items-center sm:justify-between">
            <p className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <span>© 2026 Trimmed Living LLC. All rights reserved.</span>
              <span aria-hidden="true" className="text-bone-100/25">
                |
              </span>
              <button type="button" onClick={() => setLegalDoc('privacy')} className={LEGAL_LINK}>
                Privacy Policy
              </button>
              <span aria-hidden="true" className="text-bone-100/25">
                |
              </span>
              <button type="button" onClick={() => setLegalDoc('terms')} className={LEGAL_LINK}>
                Terms of Service
              </button>
            </p>
            <a
              href="https://trimmedliving.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-bone-100/20 underline-offset-4 transition hover:text-bone-100/80 hover:decoration-bone-100/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pine-400 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950"
            >
              Looking for our DIY Guides &amp; Field Gear? Visit TrimmedLiving.com ↗
            </a>
          </div>
        </div>
      </footer>

      {legalDoc && <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} />}
    </>
  )
}
